<div>
    <mat-card appearance="outlined">
        <mat-card-title style="margin: 15px;">
            Job Card Report
        </mat-card-title>
        <mat-card-content>
            <div class="search-container">
                <form [formGroup]="requestForm">
                    <div class="search-section">
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Job Card Status</mat-label>
                            <mat-select formControlName="jobCardStatus" placeholder="Job Card Status">
                                <mat-option *ngFor="let status of jobCardStatus" [value]="status.lookupCode">
                                    {{ status.lookupValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Department</mat-label>
                            <mat-select formControlName="departmentId" placeholder="Department">
                                <mat-option *ngFor="let department of departments" [value]="department.code">
                                    {{ department.value }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Area Name</mat-label>
                            <mat-select formControlName="areaId" placeholder="Area Name">
                                <mat-option *ngFor="let area of areas" [value]="area.code">
                                    {{ area.value }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Employee</mat-label>
                            <mat-select formControlName="employeeId" placeholder="Employee">
                                <mat-option *ngFor="let employee of employees" [value]="employee.code">
                                    {{ employee.value }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Complaint Status</mat-label>
                            <mat-select formControlName="complaintStatus" placeholder="Complaint Status">
                                <mat-option *ngFor="let status of complaintStatus" [value]="status.lookupCode">
                                    {{ status.lookupValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [formGroup]="requestForm" [rangePicker]="picker">
                              <input matStartDate formControlName="startDate" placeholder="Start date">
                              <input matEndDate formControlName="endDate" placeholder="End date">
                            </mat-date-range-input>
                            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                            <mat-error *ngIf="requestForm.controls.startDate.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                            <mat-error *ngIf="requestForm.controls.endDate.hasError('matEndDateInvalid')">Invalid end date</mat-error>
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label>Complaint Category</mat-label>
                            <mat-select formControlName="categoryId" (selectionChange)="onCategorySelected($event.value)">
                                <mat-option *ngFor="let category of categoryNameOptions" [value]="category.categoryId">
                                    {{ category.categoryName }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Complaint Description</mat-label>
                            <mat-select formControlName="masterComplaintId">
                                <mat-option *ngFor="let description of categoryOptions || []" [value]="description.masterComplaintId">
                                    {{ description.complaintDescription }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </form>
                <div class="buttons">
                    <button mat-stroked-button color="warn" (click)="onReset()">Reset</button>
                    <button mat-flat-button color="primary" [disabled]="!isFormFilled()" (click)="generateJobCardReport()">Generate Report</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>